import { DUTCH_NUMBER_PREFIX, DutchPhoneNumber } from "../types/dutchPhoneNumber"
import { PhoneNumber } from "../types/phoneNumber"
import { PhoneNumberInternationalFormatter } from "./phoneNumberInternationalFormatter"
import { PhoneNumberNationalFormatter } from "./phoneNumberNationalFormatter"
import { StringFormatter, StringFormatterOptions } from "./stringFormatter"

/**
 *  A formatter that formats a phone number to a display format. A display format
 *  is our own invention that prioritizes national formatting for Dutch number and
 *  fall backs on international formatting for non-Dutch numbers.
 */
export class PhoneNumberDisplayFormatter extends StringFormatter<PhoneNumber> {
  private _nationalFormatter: PhoneNumberNationalFormatter
  private _internationalFormatter: PhoneNumberInternationalFormatter

  constructor(initialOptions: StringFormatterOptions<PhoneNumber> = {}) {
    super(initialOptions)

    this._nationalFormatter = new PhoneNumberNationalFormatter(initialOptions)
    this._internationalFormatter = new PhoneNumberInternationalFormatter(initialOptions)
  }

  protected convert(input: PhoneNumber): string {
    if (input instanceof DutchPhoneNumber || input.countryCode?.prefix === DUTCH_NUMBER_PREFIX) {
      return this._nationalFormatter.format(input) ?? this._internationalFormatter.format(input)
    }

    return this._internationalFormatter.format(input)
  }
}
